import {UploadProgress} from '../../types';

export const UploadStatus = ({progress}: {progress: UploadProgress | null}) => {
  if (!progress) return null;
  const uploading = progress.phase === 'uploading';
  return <div className="upload-progress" role="status" aria-live="polite" data-testid="knowledge-upload-status">
    <div><span>{uploading ? 'Uploading document…' : 'Reading and saving document…'}</span>
      {uploading && progress.percent !== null && <span data-testid="knowledge-upload-percent">{progress.percent}%</span>}
    </div>
    <progress max={100} value={uploading ? progress.percent ?? undefined : undefined} aria-label="Document upload progress" data-testid="knowledge-upload-progress"/>
  </div>;
};